import { RootState } from '@/store/store'
import { createSelector } from '@reduxjs/toolkit'

export const selectBanks = (state: RootState) => state.banks.banks

export const selectBankNameById = createSelector(
  [selectBanks, (_: RootState, bankId: string) => bankId],
  (banks, bankId) => {
    return banks?.find((bank) => bank.id === bankId)?.name
  }
)
